function assert(isOK, msg) {
  if (!isOK) {
    throw new Error(msg);
  }
}

function TextParser(sText) {
  let sCurText = sText;
  let prefix = "";
  let matcher;

  return {
    match: (reg, msg) => {
      matcher = sCurText.match(reg);
      assert(null !== matcher, msg);
      if (matcher.index === 0) {
        prefix = "";
        return;
      }
      prefix = sCurText.substring(0, matcher.index);
      sCurText = sCurText.substring(matcher.index);
    },
    getPreText: () => prefix,
    getToken: () => matcher[0],
    skip: (n) => {
      const skipStr = sCurText.substring(0, n);
      sCurText = sCurText.substring(n);
      return skipStr;
    },
    end: () => {
      const sText = sCurText;
      sCurText = "";
      return sText;
    },
    isEnd: () => !sCurText,
  };
}

function Store() {
  const _data = [];
  return {
    save: (str) => {
      if (str !== "") {
        _data.push(str);
      }
    },
    getText: () => _data.join(""),
  };
}

function getAttrValue(parser) {
  const startChar = parser.skip(1);
  let attrValue = startChar;
  let char = parser.skip(1);
  while (char && char !== startChar) {
    attrValue += char;
    char = parser.skip(1);
    if (char === "\\") {
      attrValue += char;
      char = parser.skip(1);
    }
  }
  attrValue += char;

  return attrValue;
}

function filterScriptTag(sHtml) {
  let isJsCode = 0;

  // 删除script代码
  return sHtml
    .split(/(<script[^>]*>|<\/script[^>]*>)/)
    .map((text) => {
      if (text.startsWith("<script")) {
        isJsCode++;
        return "";
      }
      if (text.startsWith("</script")) {
        isJsCode = Math.max(0, isJsCode - 1);
        return "";
      }
      if (isJsCode > 0) {
        return "";
      }
      return text;
    })
    .filter((text) => !!text)
    .join("");
}

function filterScriptCode(sHtml) {
  let sHtmlCode = filterScriptTag(sHtml);
  if (-1 === sHtmlCode.indexOf("<")) {
    // 纯文档，没有HTML标签，直接返回，不用处理
    return sHtmlCode;
  }

  // 删除HTML标签中的事件
  const store = Store();
  const parser = TextParser(sHtmlCode);
  parser.match(/</);
  store.save(parser.getPreText());

  while (!parser.isEnd()) {
    // tag name
    parser.match(/[\s/>]+/, "tag is not be closed");
    store.save(parser.getPreText()); // save tagname

    let sToken = parser.getToken();
    if (sToken.includes("/")) {
      // tag end
      parser.match(/>/);
      store.save(parser.getPreText());
    } else
      while (!sToken.includes(">")) {
        // skip space before attribute name
        parser.match(/[^\s]+/);
        store.save(parser.getPreText());

        // parse attributes
        parser.match(/[\s=/>]+/, "attribute is error"); // attribute name
        sToken = parser.getToken();
        const attrName = parser.getPreText();
        if (!attrName) {
          // tag结束了
          continue;
        }

        let attrStr = attrName;
        if (parser.getToken().includes("=")) {
          // save "="
          attrStr += parser.getToken();
          parser.skip(parser.getToken().length);

          // save attribute value
          attrStr += getAttrValue(parser);
        }

        // skip events
        if (!attrName.toLowerCase().startsWith("on")) {
          store.save(attrStr);
        }
      }

    try {
      parser.match(/</);
      sToken = parser.getToken();
      store.save(parser.getPreText());
    } catch {
      // the end
      store.save(parser.end());
    }
  }

  return store.getText();
}

export default {
  bind(el, binding) {
    el.innerHTML = filterScriptCode(binding.value);
  },
  update(el, binding) {
    el.innerHTML = filterScriptCode(binding.value);
  },
};
